"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchWithToken = void 0;
var handleFetchErrors_1 = require("../helpers/handleFetchErrors");
var cache_1 = require("./cache");
var getCurrentToken_1 = require("./getCurrentToken");
var handle401 = function (response) {
    if (response.status === 401) {
        (0, cache_1.clearCachedCurrentToken)();
        // When getting 401, we want to try and get a new token.
        // getCurrentToken would redirect the user to the needed login URL if needed.
        // If the new login was successful (should happen rarely) - we want to return the response with error and let the consumer decide whether to make another request.
        return (0, getCurrentToken_1.getCurrentToken)().then(function () { return response; });
    }
    return response;
};
var fetchWithToken = function (url, fetchData) {
    return (0, getCurrentToken_1.getCurrentToken)()
        .then(function (_a) {
        var accessToken = _a.accessToken;
        return fetch(url, __assign(__assign({}, fetchData), { headers: __assign(__assign({}, (fetchData && fetchData.headers)), { Authorization: "Bearer " + accessToken }) }));
    })
        .then(handle401)
        .then(handleFetchErrors_1.default)
        .then(function (res) { return res.text(); }) // check if res body exists before trying to json parse it - to avoid parsing errors
        .then(function (text) { return (text ? JSON.parse(text) : {}); });
};
exports.fetchWithToken = fetchWithToken;
